import { INSIDER_PARAM_NAMES } from '@/Groups/Polymarket/private/constants/config';

export const buildTradesUrl = (params = {}) => {
  const {
    bet_value, top_trades_24h, top_pnl_24h,
    user, market, category,
    insider_mode, fresh_wallet, active_hold, insider_params,
  } = params;

  const searchParams = new URLSearchParams();
  if (insider_mode)   searchParams.append('insider', 'insider');
  if (bet_value)      searchParams.append('bet_value', bet_value);
  if (top_trades_24h) searchParams.append('top_trades_24h', 'True');
  if (top_pnl_24h)    searchParams.append('top_pnl_24h', 'True');
  if (user)           searchParams.append('user', user);
  if (market)         searchParams.append('market', market);
  // Категории не применимы при drill-down по user/market; в insider-режиме применимы (polysights-паритет).
  if (!user && !market && category) searchParams.append('category', category);
  // fresh_wallet/active_hold только в insider-режиме.
  // Дефолты: fresh_wallet=true, active_hold=false. В URL пишем только не-дефолт.
  if (insider_mode && fresh_wallet === false) searchParams.append('fresh_wallet', 'false');
  if (insider_mode && active_hold === true) searchParams.append('active_hold', 'true');
  // Пользовательские оверрайды порогов — только в insider-режиме, только непустые значения.
  if (insider_mode && insider_params) {
    INSIDER_PARAM_NAMES.forEach((name) => {
      const val = insider_params[name];
      if (val !== null && val !== undefined) searchParams.append(name, val);
    });
  }

  const queryString = searchParams.toString();
  return `/polymarket${queryString ? '?' + queryString : ''}`;
};